import { scrollBarStyle } from 'src/styles/CommonStyles.styled';
import styled from 'styled-components';
import media from '../../../styles/Media.styled';

export const SessionOutPopUpDiv = styled.div`
    width: 400px;
    display: flex;
    flex-direction: column;
    max-height: 80vh;
    ${media.mobileDevice`
         width:auto;              
    `}
`;

export const PopUpText = styled.div`
    ${scrollBarStyle}
    font: ${({ font }) => (font ? font : '16px Avenir Next World')};
    font-family: 'AvenirNextWorld Regular';
    color: #000000;
    letter-spacing: -0.11px;
    opacity: 1;
    overflow-y: scroll;
    line-height: ${({ lineHeight }) => lineHeight};
    flex-grow: ${({ flexGrow }) => (flexGrow ? flexGrow : '0')};
    ${media.mobileDevice` 
        height: ${({ height }) => (height ? height : '190px')};
        max-height: ${({ maxHeight }) => (maxHeight ? maxHeight : '190px')};
        font: ${({ font }) => (font ? font : '15px Avenir Next World')};;
        font-family:'AvenirNextWorld Regular';
    `};
`;

export const PopUpDesktopWrap = styled.div`
    display: flex;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : ''};
    margin-right: 150px;
    ${media.mobileDevice` 
        flex-wrap:wrap;
        margin-right:92px;
    `};
`;

export const PopUpTitleText = styled.b`
    font-size: 16px;
    ${media.mobileDevice` 
        font-size:16px;
    `};
`;

export const PopUpTitleSubText1 = styled.span`
    font-size: 14px;
    ${media.mobileDevice` 
        font-size:14px;
    `};
`;

export const ButtonFooter = styled.div`
    display: flex;
    justify-content: center;
    position: sticky;
    bottom: 0;
`;
